var $b806487b79a47647$exports = {};
$b806487b79a47647$exports = {
    "breadcrumbs": `Struktura nawigacyjna`
};


export {$b806487b79a47647$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
